import React from 'react';
import type {MessageDescriptor} from 'react-intl';
import {useAutoMapper} from '@igp/shared/auto-mapper';
import {DownloadCsvButton} from '@igp/shared/components/download';
import type {UseDownloadProps, UseDownloadResult} from '@igp/shared/redux/download';
import {useDownload} from '@igp/shared/redux/download';

import {PlayerEcologyWeeklyColumnsTypeName, PlayerEcologyWeeklyServiceTypes, PlayerEcologyWeeklyViewModelKeysTypeName} from '../constants';
import type {PlayerEcologyWeeklyColumns, PlayerEcologyWeeklyViewModelKeys} from '../types';

import {localizedHeaders} from './DataGrid';

type PlayerEcologyWeeklyDownloadCsvButtonProps = Pick<
    UseDownloadProps<PlayerEcologyWeeklyViewModelKeys>,
    'filename' | 'filter' | 'total' | 'hasSummary'
> & {
    columns: PlayerEcologyWeeklyColumns[];
};

function usePlayerEcologyWeeklyDownload({columns, ...props}: PlayerEcologyWeeklyDownloadCsvButtonProps): UseDownloadResult {
    const mapper = useAutoMapper();
    const keys = columns.map(c =>
        mapper.map<PlayerEcologyWeeklyColumns, PlayerEcologyWeeklyViewModelKeys>(
            c,
            PlayerEcologyWeeklyColumnsTypeName,
            PlayerEcologyWeeklyViewModelKeysTypeName
        )
    );
    const {handleDownload, isProgress} = useDownload<PlayerEcologyWeeklyViewModelKeys>({
        ...props,
        strategySymbol: PlayerEcologyWeeklyServiceTypes.downloadServerStrategy,
        headersLocalization: localizedHeaders as Record<PlayerEcologyWeeklyViewModelKeys, MessageDescriptor>,
        keys,
        mode: 'server',
    });

    return {handleDownload, isProgress};
}

export function PlayerEcologyWeeklyDownloadCsvButton(props: PlayerEcologyWeeklyDownloadCsvButtonProps) {
    const {handleDownload, isProgress} = usePlayerEcologyWeeklyDownload(props);

    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={isProgress || props.total === 0} />;
}
